/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_DeveloperInputs */

const id_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembang`)
};

const ms_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangun`)
};

const da_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udvikler`)
};

const de_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler`)
};

const en_us2_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const es_es2_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const es_mx2_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const fil_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const fr_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur`)
};

const it_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatore`)
};

const hu_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlesztő`)
};

const nl_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontwikkelaar`)
};

const no_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvikler`)
};

const pl_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deweloper`)
};

const pt_br2_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

const pt_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

const ro_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezvoltator`)
};

const fi_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehittäjä`)
};

const sv_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvecklare`)
};

const vi_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà phát triển`)
};

const tr_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirici`)
};

const cs_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vývojář`)
};

const bg_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const ru_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const uk_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розробник`)
};

const ar_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المطور`)
};

const hi_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर`)
};

const th_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้พัฒนา`)
};

const ja_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発元`)
};

const zh_cn2_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发商`)
};

const zh_hant1_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開發商`)
};

const ko_search_accordion_developer = /** @type {(inputs: Search_Accordion_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발자`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Search_Accordion_DeveloperInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_developer = /** @type {((inputs?: Search_Accordion_DeveloperInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_DeveloperInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_developer(inputs)
	if (locale === "ms") return ms_search_accordion_developer(inputs)
	if (locale === "da") return da_search_accordion_developer(inputs)
	if (locale === "de") return de_search_accordion_developer(inputs)
	if (locale === "en-US") return en_us2_search_accordion_developer(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_developer(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_developer(inputs)
	if (locale === "fil") return fil_search_accordion_developer(inputs)
	if (locale === "fr") return fr_search_accordion_developer(inputs)
	if (locale === "it") return it_search_accordion_developer(inputs)
	if (locale === "hu") return hu_search_accordion_developer(inputs)
	if (locale === "nl") return nl_search_accordion_developer(inputs)
	if (locale === "no") return no_search_accordion_developer(inputs)
	if (locale === "pl") return pl_search_accordion_developer(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_developer(inputs)
	if (locale === "pt") return pt_search_accordion_developer(inputs)
	if (locale === "ro") return ro_search_accordion_developer(inputs)
	if (locale === "fi") return fi_search_accordion_developer(inputs)
	if (locale === "sv") return sv_search_accordion_developer(inputs)
	if (locale === "vi") return vi_search_accordion_developer(inputs)
	if (locale === "tr") return tr_search_accordion_developer(inputs)
	if (locale === "cs") return cs_search_accordion_developer(inputs)
	if (locale === "bg") return bg_search_accordion_developer(inputs)
	if (locale === "ru") return ru_search_accordion_developer(inputs)
	if (locale === "uk") return uk_search_accordion_developer(inputs)
	if (locale === "ar") return ar_search_accordion_developer(inputs)
	if (locale === "hi") return hi_search_accordion_developer(inputs)
	if (locale === "th") return th_search_accordion_developer(inputs)
	if (locale === "ja") return ja_search_accordion_developer(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_developer(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_developer(inputs)
	return ko_search_accordion_developer(inputs)
});
export { search_accordion_developer as "search.accordion.developer" }